import { useMemo } from "react";
import { matchPath, useLocation } from "react-router-dom";

import { PREVIEW_DOMAIN, PROD_DOMAIN, URLS } from "@const/urls";

export default function useCheckLocation() {
  const { pathname } = useLocation();

  const isCheckout = useMemo(() => Boolean(matchPath(URLS.CHECKOUT, pathname)), [pathname]);
  const isEventPage = useMemo(
    () => Boolean(matchPath(URLS.TEKKEN, pathname) || Boolean(matchPath(URLS.TEKKEN_NIKE, pathname))),
    [pathname],
  );

  const isPreview = useMemo(() => window.location.href.includes(PREVIEW_DOMAIN), []);
  const isProd = useMemo(() => window.location.href.includes(PROD_DOMAIN), []);
  const isLocal = useMemo(() => window.location.href.includes("localhost"), []);

  return { isCheckout, isPreview, isProd, isLocal, isEventPage };
}
